import { render, staticRenderFns } from "./StudentShowAchievement.vue?vue&type=template&id=08988bb8&scoped=true&"
import script from "./StudentShowAchievement.vue?vue&type=script&lang=js&"
export * from "./StudentShowAchievement.vue?vue&type=script&lang=js&"
import style0 from "./StudentShowAchievement.vue?vue&type=style&index=0&id=08988bb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08988bb8",
  null
  
)

export default component.exports